export default {
  SUBMIT_ID: "submitId",
  DISCLAIMER_VISIBLE: "disclaimerVisible",
  REQUIRED: "requiredCookies",
  ADVERTS: "advertsCookies",
  FUNCTIONAL: "functionalCookies",
  ANALYTICS: "analyticsCookies",
}
